import { 
  DeviceAlertComparisonType,
  UpdateAlertConfigurationInput,
  UpdateBasicAlertConfigurationInput
} from "@/__generated__/graphql";

enum BaseNotificationDelay {
  OK = 3600 * 8,
  WARNING = 3600 * 8,
  CRITICAL = 3600,
};


function basicToAdvanced(input: UpdateBasicAlertConfigurationInput): UpdateAlertConfigurationInput {
  const basicAlertConfig = input;

  const alertConfig: UpdateAlertConfigurationInput = {
    deviceId: basicAlertConfig.deviceId,
    metric: basicAlertConfig.alertType,
    ok: {
      comparisonType: DeviceAlertComparisonType.InsideRange,
      notificationDelaySec: BaseNotificationDelay.OK,
      thresholdMin: basicAlertConfig.min,
      thresholdMax: basicAlertConfig.max,
      unit: basicAlertConfig.unit
    },
    warning: {
      comparisonType: DeviceAlertComparisonType.OutsideRange,
      notificationDelaySec: BaseNotificationDelay.WARNING,
      thresholdMin: basicAlertConfig.min,
      thresholdMax: basicAlertConfig.max,
      unit: basicAlertConfig.unit
    },
    critical: {
      comparisonType: DeviceAlertComparisonType.Above,
      notificationDelaySec: BaseNotificationDelay.CRITICAL,
      thresholdValue: basicAlertConfig.overflow,
      unit: basicAlertConfig.unit
    }
  };
  
  return alertConfig;
}

export { basicToAdvanced };